import { LinkIcon } from "@chakra-ui/icons";
import { Box } from "@chakra-ui/react";
import { useState } from "react";
import { FormattedMessage } from "react-intl";

import { ApiKeyCreateResponse } from "@nens/rana/api-v1";
import { RanaButton } from "@nens/ranalib";

import { usePublicationStore } from "../../_internal";
import { getIsChanged, getIsPublishedVersion } from "../../store/selectors";

import { UnsavedChangesModal } from "./components/share-unsaved-changes-modal";
import { PublicationDetailShareCreateConfirm } from "./share-create-confirm";
import { PublicationDetailShareCreateForm } from "./share-create-or-edit";

export function PublicationDetailShareCreate() {
  const [openModal, setOpenModal] = useState<"share-modal" | "unsaved-changes" | null>(null);
  const onClose = () => setOpenModal(null);
  const isPublished = usePublicationStore(getIsPublishedVersion);
  const isChanged = usePublicationStore(getIsChanged);

  const onOpen = () =>
    isPublished && isChanged ? setOpenModal("unsaved-changes") : setOpenModal("share-modal");
  const [shareKey, setShareKey] = useState<ApiKeyCreateResponse | undefined>(undefined);

  return (
    <Box>
      <RanaButton variant="tertiary" leftIcon={<LinkIcon />} onClick={onOpen}>
        <FormattedMessage id="reference.share_publication" defaultMessage="Share publication" />
      </RanaButton>

      {openModal === "unsaved-changes" && (
        <UnsavedChangesModal onClose={onClose} proceed={() => setOpenModal("share-modal")} />
      )}

      {openModal === "share-modal" &&
        (shareKey ? (
          <PublicationDetailShareCreateConfirm
            shareKey={shareKey}
            onClose={() => {
              onClose();
              setShareKey(undefined);
            }}
          />
        ) : (
          <PublicationDetailShareCreateForm setShareKey={setShareKey} onClose={onClose} />
        ))}
    </Box>
  );
}
